import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.default.css"

// Connects to data-controller="tag-select"
// Supports:
//   data-tag-select-url-value    — remote search endpoint
//   data-tag-select-options-value — preloaded JSON array of strings
//   data-tag-select-max-items-value — max items (1 = single select, default unlimited)
export default class extends Controller {
  static values = {
    url: String,
    options: Array,
    maxItems: Number,
    create: Boolean,
  }

  connect() {
    const hasPreloaded =
      this.hasOptionsValue && this.optionsValue.length > 0
    const isSingle = this.hasMaxItemsValue && this.maxItemsValue === 1

    const selectedItems = (isSingle ? [this.element.value] : this.element.value.split(","))
      .map((value) => value.trim())
      .filter(Boolean)

    const config = {
      plugins: isSingle ? [] : ["remove_button"],
      create: this.hasCreateValue ? this.createValue : !hasPreloaded,
      items: selectedItems,
      delimiter: ",",
      persist: false,
      createOnBlur: !isSingle,
      maxItems: isSingle ? 1 : null,
      maxOptions: hasPreloaded ? null : 20,
      openOnFocus: hasPreloaded,
      render: {
        no_results: () =>
          '<div class="no-results" style="padding:8px;color:#999;">No results</div>',
      },
    }

    // Retain every selected tag, including values not in a preloaded vocabulary.
    config.options = [...new Set([...(hasPreloaded ? this.optionsValue : []), ...selectedItems])]
      .map((value) => ({ value, text: value }))

    // Remote search
    if (this.hasUrlValue && this.urlValue) {
      config.load = (query, callback) => {
        if (!query.length) return callback()
        fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
          .then((res) => res.json())
          .then((items) => {
            callback(items.map((item) => ({ value: item, text: item })))
          })
          .catch(() => callback())
      }
    }

    this.tomSelect = new TomSelect(this.element, config)

    if (!isSingle) {
      this.tomSelect.on("item_add", () => {
        this.tomSelect.setTextboxValue("")
        this.tomSelect.refreshOptions(false)
      })
    }
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
